import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import ODataUtils from "../../../utils/odata.utils";
import { ApiCommunicationConstants } from "../../../constants/api-constants/api-communication.constants";
import { ApiTemplateConstants } from "../../../constants/api-constants/api-template.constants";
let SendLetterService = class SendLetterService {
    http;
    constructor(http) {
        this.http = http;
    }
    getTemplateAttachments(templateId) {
        return this.http.get(`${ApiTemplateConstants.URL}/${templateId}/${ApiTemplateConstants.FUNCTION_GET_TEMPLATE_ATTACHMENT}`, { responseType: "blob" })
            .pipe(map(response => {
            return response;
        }));
    }
    getLetterTemplates(stepName, moduleId) {
        const params = {
            $expand: "attachment",
            $filter: `moduleId eq ${moduleId} and stepName eq '${ODataUtils.encryptQueryContent(stepName)}'`
        };
        return this.http.get(`${ApiTemplateConstants.URL}`, { params }).pipe(map(response => {
            return response;
        }));
    }
    logCommunication(communication, jobId, stepName, stepId) {
        const request = {
            communication,
            jobId,
            stepName,
            stepId
        };
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_LOG_COMMUNICATION}`, request)
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
SendLetterService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SendLetterService);
export { SendLetterService };
